import { getThemeAsset } from "@utils/theme";
import { motion } from "framer-motion";
import { ANIMATION_STATE, circleVariants } from "../utils";

interface SkinnerBoxBackgroundProps {
  animationState: ANIMATION_STATE;
  zIndex: number;
}

const SkinnerBoxBackground = ({ animationState, zIndex }: SkinnerBoxBackgroundProps) => {
  const imgShine = getThemeAsset("/skinner-box/shine.png");

  return (
    <>
      {/* Background shine image at the bottom */}
      <img
        src={imgShine}
        alt="Shine background"
        className="absolute bottom-[8px] left-1/2 flex h-[96px] w-[98px] shrink-0 -translate-x-1/2 items-center justify-center"
        style={{ clipPath: "circle(40px at 50% calc(50% - 8px))", zIndex }}
      />

      {/* Circle BG (rotating) */}
      <motion.div
        className="absolute inset-0 m-auto flex h-[80px] w-[80px] shrink-0 items-center justify-center rounded-full opacity-60"
        style={{ zIndex }}
        variants={circleVariants}
        initial={ANIMATION_STATE.IDLE}
        animate={animationState}
      >
        <div className="absolute inset-0 rounded-full border-2 border-stroke-base" />
        <img
          src={imgShine}
          alt="Circle BG"
          className="h-full w-full rounded-full object-contain"
        />
      </motion.div>
    </>
  );
};

export default SkinnerBoxBackground;
